export const Job = {
  GET_JOB_LIST: "GET_JOB_LIST",
  TRIGGER_JOB: "TRIGGER_JOB",
  UPDATE_JOB_LIST: "UPDATE_JOB_LIST",
  JOB_LIST_SUCCESS: "JOB_LIST_SUCCESS",
};
